import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/payment'
const CollectionApi = {
  getPaymentFeeDetails (input, success, failure) {
    ajax.get(
      `${BASE_URL}/payment-fee-details/get`,
      input,
      success,
      failure
    )
  },
  updatePlanSetUp (input, success, failure) {
    ajax.put(
      `${BASE_URL}/payment-fee/update`,
      input,
      success,
      failure
    )
  },
  manuallySetupInitialize (input, success, failure) {
    ajax.get(
      `${BASE_URL}/manually-set-up/initialize`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  manuallySetupCalculate (input, success, failure) {
    ajax.post(
      `${BASE_URL}/manually-set-up/calculateFee`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getMultipleInfo (input, success, failure) {
    ajax.get(
      `${BASE_URL}/payment-plan-assigned/multiple/get`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  previewMultiple (input, success, failure) {
    ajax.post(
      `${BASE_URL}/payment-plan-assigned/multiple/preview`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  saveMultiple (input, success, failure) {
    ajax.post(
      `${BASE_URL}/payment-plan-assigned/multiple/save`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getSlaveLoan (input, success, failure) {
    ajax.get(
      `${BASE_URL}/slave-loan/get`,
      input,
      success,
      failure
    )
  },
  uploadMultipartFile (conditions, success, failure) {
    const form = new FormData()
    form.append('multipartFile', conditions.multipartFile)
    form.append('collectionProvider', conditions.collectionProvider)
    form.append('portfolioId', conditions.portfolioId)
    form.append('transactionProvider', conditions.transactionProvider)
    ajax.post(
      `${BASE_URL}/update/pay-dit-plan-file`,
      form,
      success,
      failure
    )
  },
  uploadBalanceFile (conditions, success, failure) {
    const form = new FormData()
    form.append('file', conditions.file)
    form.append('portfolioId', conditions.portfolioId)
    ajax.post(
      `${BASE_URL}/upload/balance-file`,
      form,
      success,
      failure
    )
  },
  uploadReturnFile (conditions, success, failure) {
    const form = new FormData()
    form.append('file', conditions.file)
    form.append('portfolioId', conditions.portfolioId)
    form.append('returnType', conditions.returnType)
    form.append('collectionProvider', conditions.collectionProvider)
    ajax.post(
      `${BASE_URL}/wa/return-file`,
      form,
      success,
      failure,
      { showLoading: true }
    )
  },
  getTransactionProvider (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/wa/transaction-provider`,
      input,
      success,
      failure
    )
  },
  getTransactionTask (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/page-transaction-task`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getTransactionTaskToItem (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/page-transaction-task-item`,
      input,
      success,
      failure
    )
  },
  queryEmail (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/query`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  queryPayditInfo (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/wa/query-paydit-info`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  sendEmail (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/wa/send-email`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  sendAllEmail (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/wa/send-all-email`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  generateFile (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/wa/generate-file`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  generatePayDitFile (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/wa/generate-paydit-info`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getWAQueueItem (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/load-by-page`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getOverflowQueueItem (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/load-by-page`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getWAQueueCount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/count`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getOverflowQueueCount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/count`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  cancelOperation (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/single/cancel`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  moveToCollection (input, success, failure) {
    ajax.post(
      `${BASE_URL}/loan-status/move-to`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  confirmCollection (input, success, failure) {
    ajax.put(
      `${BASE_URL}/loan-status/confirm`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getLoanStatusList (input, success, failure) {
    ajax.get(
      `${BASE_URL}/loan-status-list/get`,
      input,
      success,
      failure
    )
  },
  getConfirmLoanStatusList (input, success, failure) {
    ajax.get(
      `${BASE_URL}/confirm-list/get`,
      input,
      success,
      failure
    )
  },
  getLoanDetailsBasic (input, success, failure) {
    ajax.get(
      `${BASE_URL}/loan-detail/fetch-for-collection`,
      input,
      success,
      failure
    )
  },
  manuallyPaidOff (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/manually/paid-off`,
      input,
      success,
      failure
    )
  },
  getMaxPartialAmount (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/max-partial-amount/get`,
      input,
      success,
      failure
    )
  },
  getMaxPartialBankFee (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/max-partial-bank-fee/get`,
      input,
      success,
      failure
    )
  },
  getOverFlow (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/overflow-info/list`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  resolveOverFlow (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/resolve/overflow`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  saveAdjustAmount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/adjust-amount/save`,
      input,
      success,
      failure
    )
  },
  previewAdjustAmount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/adjust-amount/preview`,
      input,
      success,
      failure
    )
  },
  getButtonList (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/button/list`,
      input,
      success,
      failure
    )
  },
  historyFilterResult (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/filter-sys-log-list`,
      input,
      success,
      failure
    )
  },
  initMultipleInfo (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/init-multiple-info`,
      input,
      success,
      failure
    )
  }
}
export { CollectionApi }
